import { Callout } from '@/components/Callout';

import { ENROLMENT_COPY } from '../copy';
import { EnrolmentHeading } from './EnrolmentHeading';
import { EnrolmentShell } from './EnrolmentShell';

/**
 * Frame *05 · Locked* — three wrong PINs on this browser's token [AC-5; decisions 0052, 0203].
 *
 * ⛔ **The keypad is gone, and the absence is structural rather than a judgement**: `05 · Locked` is the one
 * state in the section whose content is a `Heading` and a `Callout` and nothing else — no `Keypad` child, no
 * `PIN dots`, not even the `No sign-in` note. ⛔ **And there is no way out**: no retry, no timer, no
 * *unlock*. An admin clears it from the admin panel and nothing on this device can [KAD-6f].
 *
 * ⛔ **The lock is the SERVER's.** Nothing here counted to three; this screen renders a word the server said.
 *
 * The callout is the design system's `Tone=Error` variant (`11878:21240`) — the darker, red-tinted one —
 * where frames 03 and 04 use `Tone=Warning`. The two reading differently is the point: a countdown is a
 * retry and this is not.
 */
export function LockedScreen() {
  return (
    <EnrolmentShell>
      <div className="flex w-full flex-col items-center gap-6 pb-8 pt-2">
        <EnrolmentHeading
          body={ENROLMENT_COPY.lockedBody}
          eyebrow={ENROLMENT_COPY.eyebrow}
          heading={ENROLMENT_COPY.lockedHeading}
        />

        {/* A lockout that only renders visually strands a staffer holding a dead tablet [AC-10]. */}
        <div className="w-full" role="alert">
          <Callout tone="error">{ENROLMENT_COPY.lockedCallout}</Callout>
        </div>
      </div>
    </EnrolmentShell>
  );
}
